const Navbar = () => {
    return (
        <header id="header" className="header d-flex align-items-center fixed-top">
            <div className="container position-relative d-flex align-items-center justify-content-between">
                <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">
                    <img src="assets/images/logo-blanco.png" alt="" />
                </a>

                <nav id="navmenu" className="navmenu">
                    <ul>
                        <li><a href="#hotel-hero" className="active">Inicio</a></li>
                        <li><a href="#about-home">Conócenos</a></li>
                        <li><a href="#amenities-cards">Instalaciones</a></li>
                        <li><a href="#amenities">Servicios</a></li>
                        <li><a href="#contact">Contacto</a></li>
                        <li><a href="/login" className="d-block d-sm-none">Acceso a clientes</a></li>

                    </ul>
                    <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                </nav>

                <a className="btn-getstarted d-none d-sm-block" href="/login">Acceso a clientes</a>
            </div>
        </header>
    )
}

export default Navbar;